import React, { Component } from 'react';

import { USER_ROLE_ADMIN } from 'common/userRoles';

import { SCREEN_ID_ADMIN_PARTNER_SALES } from 'client/constants/screenIds';

import SrH1 from 'client/components/SrH1';
import SrPage from 'client/components/SrPage';
import SrDataTablePartnerSales from 'client/components/SrDataTablePartnerSales';

import allowedRoles from 'client/helpers/allowedRoles';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

@withTransitionHook
@allowedRoles({
  roles: [USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_ADMIN_PARTNER_SALES)
@withScrollToTop
class AdminPartnerSalesPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Partner Sales | Sunroom Rentals',
  });

  render() {
    return (
      <SrPage navbarProps={{ redirectLogoTo: '/admin' }}>
        <div className="width-90">
          <SrH1>partner sales</SrH1>
          <SrDataTablePartnerSales />
        </div>
      </SrPage>
    );
  }
}

AdminPartnerSalesPage.displayName = 'AdminPartnerSalesPage';

export default AdminPartnerSalesPage;
